export function obterListaTipoEntidadeGovernamental() {
  return (
    [
      { label: '', value: null },
      { label: 'União', value: 'UNIAO' },
      { label: 'Estado', value: 'ESTADO' },
      { label: 'Distrito Federal', value: 'DISTRITOFEDERAL' },
      { label: 'Município', value: 'MUNICIPIO' },
    ]
  );
}
